import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';

const Header = ({ title, search, bell, partnerName, initials, searchPlaceholder }) => {
  const navigate = useNavigate();
  const { unreadCount = 0 } = useNotifications() || {};

  const badgeCount = unreadCount > 99 ? '99+' : unreadCount;

  return (
    <header className="dashboard-header">
      <h1>{title}</h1>
      <div className="dashboard-header-right">
        {search && (
          <input
            className="dashboard-search"
            placeholder={searchPlaceholder}
          />
        )}
        {bell && (
          <button
            type="button"
            className="header-bell"
            aria-label={
              unreadCount > 0
                ? `${unreadCount} unread notifications`
                : 'Notifications'
            }
            onClick={() => navigate('/notifications')}
          >
            🔔
            {unreadCount > 0 && (
              <span className="bell-dot">
                <span className="bell-count">{badgeCount}</span>
              </span>
            )}
          </button>
        )}
        {partnerName && (
          <div className="header-partner-chip">
            <div className="sidebar-avatar small">{initials}</div>
            <div className="header-partner">
              <strong>{partnerName}</strong>
              <span>Partner</span>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;